(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Traveling Merchant": {
      triggers: [{
        on: "move", self: true,
        label: "discard 1, then draw 1",
        program: [{ op: "discard", n: 1 }, { op: "draw", n: 1 }],
      }],
    },

    "Sneaky Deckhand": { playToOpenBf: true },

    "Sai Scout": { playToOpenBf: true },

    "Maddened Marauder": {
      targets: [{ bind: "t", spec: { type: "unit", atBf: true }, prompt: "Move which unit to its base?" }],
      play: [{ op: "move", to: "$t", dest: "base" }],
    },

    "Gust": {
      targets: [{ bind: "t", spec: { type: "unit", atBf: true, maxMight: 3 }, prompt: "Return a unit with 3 Might or less to hand" }],
      play: [{ op: "toHand", to: "$t" }],
    },

    "Morbid Return": {
      targets: [{ bind: "t", spec: { type: "unit", zone: "trash" }, prompt: "Return a unit from your trash to your hand" }],
      play: [{ op: "toHand", to: "$t" }],
    },

    "Cemetery Attendant": {
      targets: [{ bind: "t", spec: { type: "unit", zone: "trash" }, prompt: "Return a unit from your trash to your hand" }],
      play: [{ op: "toHand", to: "$t" }],
    },

    "Undercover Agent": {
      deathknell: [
        { op: "discard", n: 2 },
        { op: "draw", n: 2 },
      ],
    },

    "Zaunite Bouncer": {
      play: [
        { op: "choose", bind: "t", spec: { type: "unit", atBf: true, other: true }, prompt: "Return another unit at a battlefield to its owner's hand" },
        { op: "toHand", to: "$t" },
      ],
    },

    "Mindsplitter": {
      play: [
        { op: "choose", bind: "t", spec: { zone: "hand", enemy: true }, prompt: "They reveal their hand — choose a card they discard" },
        { op: "discard", to: "$t" },
      ],
    },

    "Tideturner": {
      play: [{
        op: "may", prompt: "Swap locations with a friendly unit?", then: [
          { op: "choose", bind: "t", spec: { type: "unit", friendly: true, other: true, otherLoc: true }, prompt: "Swap locations with which unit?" },
          { op: "swapLoc", a: "source", b: "$t" },
        ],
      }],
    },

    "Invert Timelines": {
      play: [
        { op: "discard", all: true, who: "each" },
        { op: "draw", n: 4, who: "each" },
      ],
    },

    "Jinx, Rebel": {
      triggers: [{
        on: "discardedBatch", you: true, label: "ready + might",
        program: [
          { op: "ready", to: "source" },
          { op: "grant", to: "source", might: 1 },
        ],
      }],
    },

    "Twisted Fate, Gambler": {
      triggers: [{
        on: "attack", self: true, label: "destiny draw",
        program: [
          { op: "revealTopRune", varKey: "dom" },
          {
            op: "if", cond: { k: "varEq", key: "dom", value: "fury" }, then: [
              { op: "choose", bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Red card: deal 2 to which enemy unit here?" },
              { op: "deal", to: "$t", n: 2 },
              { op: "deal", spec: { type: "unit", enemy: true, here: true }, except: "t", n: 1 },
            ],
          },
          { op: "if", cond: { k: "varEq", key: "dom", value: "mind" }, then: [{ op: "draw", n: 1 }] },
          {
            op: "if", cond: { k: "varEq", key: "dom", value: "order" }, then: [
              { op: "choose", bind: "s", spec: { type: "unit", enemy: true }, prompt: "Gold card: stun which enemy unit?" },
              { op: "stun", to: "$s" },
            ],
          },
        ],
      }],
    },

    "Ember Monk": {
      triggers: [
        {
          on: "played", you: true, label: "kindled",
          condSpec: { k: "and", conds: [{ k: "evOther" }, { k: "evFromFacedown" }] },
          program: [{ op: "grant", to: "source", might: 2 }],
        },
        {
          on: "finalizedCard", you: true, label: "kindled",
          condSpec: {
            k: "and",
            conds: [{ k: "evOther" }, { k: "evFromFacedown" }, { k: "evType", type: "spell" }],
          },
          program: [{ op: "grant", to: "source", might: 2 }],
        },
      ],
    },

    "Rhasa the Sunderer": { costMod: { k: "perTrash", each: 1, min: 0 } },

    "Miss Fortune, Buccaneer": { playToOpenBf: true, grantsPlayToOpenBf: true },

    "Kog'Maw, Caustic": {
      deathknell: [{ op: "deal", spec: { type: "unit", here: true }, n: 4 }],
    },

    "Fight or Flight": {
      targets: [{ bind: "t", spec: { type: "unit", atBf: true }, prompt: "Move which unit to its base?" }],
      play: [{ op: "move", to: "$t", dest: "base" }],
    },

    "Ride the Wind": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Move and ready which unit?" }],
      play: [
        { op: "move", to: "$t" },
        { op: "ready", to: "$t" },
      ],
    },

    "Acceptable Losses": {
      play: [
        { op: "choose", bind: "g1", spec: { type: "gear", friendly: true }, prompt: "Kill which of your gear?" },
        { op: "kill", to: "$g1" },
        { op: "choose", bind: "g2", spec: { type: "gear", enemy: true }, byOpponent: true, prompt: "Kill which of your gear?" },
        { op: "kill", to: "$g2" },
      ],
    },

    "Fading Memories": {
      targets: [{
        bind: "t",
        spec: { orSpecs: [{ type: "unit", atBf: true }, { type: "gear" }] },
        prompt: "Give which unit at a battlefield (or gear) [Temporary]?",
      }],
      play: [{ op: "grant", to: "$t", keyword: "temporary", dur: "perm" }],
    },

    "Stacked Deck": {
      play: [{ op: "lookTopTake", n: 3, take: "hand", prompt: "Put 1 of the top 3 into your hand" }],
    },

    "Whirlwind": {
      play: [
        { op: "choose", bind: "b", spec: { type: "unit", enemy: true }, byOpponent: true, min: 0, prompt: "You may return a unit to its owner's hand" },
        { op: "toHand", to: "$b" },
        { op: "choose", bind: "a", spec: { type: "unit" }, min: 0, prompt: "You may return a unit to its owner's hand" },
        { op: "toHand", to: "$a" },
      ],
    },

    "Possession": {
      targets: [{ bind: "t", spec: { type: "unit", enemy: true, atBf: true }, prompt: "Take control of which enemy unit?" }],
      play: [{ op: "takeControl", to: "$t", recall: true }],
    },

    "The Syren": {
      abilities: [{
        label: "1 energy, exhaust: move a friendly unit at a battlefield to your base", exhausts: true, cost: { energy: 1 },
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", friendly: true, atBf: true }, prompt: "Move which unit to base?" },
          { op: "move", to: "$t", dest: "base" },
        ],
      }],
    },

    "Stealthy Pursuer": {
      triggers: [{
        on: "move", you: true, optional: true, label: "follow the moving unit",
        condSpec: { k: "and", conds: [{ k: "evFriendly" }, { k: "evOther" }, { k: "selfReady" }, { k: "evFromSelfLoc" }] },
        program: [{ op: "move", to: "source", destRef: "$ev" }],
      }],
    },

    "Pack of Wonders": {
      abilities: [{
        cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
        exhausts: true, label: "Pack of Wonders",
        targets: [{
          bind: "t",
          spec: { orSpecs: [
            { type: "unit", friendly: true },
            { type: "gear", friendly: true, other: true },
            { zone: "facedown", friendly: true },
          ] },
          prompt: "Return which card to its owner's hand?",
        }],
        program: [{ op: "toHand", to: "$t" }],
      }],
    },

    "Scrapheap": {
      play: [{ op: "draw", n: 1 }],
      triggers: [{
        on: "dies", self: true, label: "draw 1",
        condSpec: { k: "evSnapshotSelf" },
        program: [{ op: "draw", n: 1 }],
      }],
      trashTriggers: [{
        on: "discarded", label: "draw 1",
        condSpec: { k: "evSelfOrTrashed" },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Treasure Trove": {
      abilities: [{
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] },
        exhausts: true, label: "Treasure Trove",
        program: [{ op: "kill", to: "source", credit: false }],
      }],
      triggers: [{
        on: "leavesBoard", self: true, label: "draw 1 and channel 1 exhausted",
        program: [{ op: "draw", n: 1 }, { op: "channel", n: 1, exhausted: true }],
      }],
    },

    "Kayn, Unleashed": {
      damageImmuneCond: { k: "movedAtLeast", n: 2 },
    },

    "Soulgorger": {
      play: [{
        op: "may", prompt: "Play a unit from your trash, ignoring its Energy cost?", then: [
          { op: "choose", bind: "_u", spec: { type: "unit", zone: "trash" }, prompt: "Play which unit from your trash?" },
          { op: "playFrom", to: "$_u", waive: "energy" },
        ],
      }],
    },

    "The Harrowing": {
      targets: [{ bind: "t", spec: { type: "unit", zone: "trash" }, prompt: "Play which unit from your trash?" }],
      play: [{ op: "playFrom", to: "$t", waive: "energy" }],
    },

    "Yasuo, Windrider": {
      triggers: [{
        on: "move", self: true, label: "third move: score 1",
        condSpec: { k: "movedExactly", n: 3 },
        program: [{ op: "points", n: 1 }],
      }],
    },

    "Nocturne, Horrifying": {
      lookPlayCost: { energy: 0, pips: 0, anyPower: 1, domains: null },
    },

    "Seal of Discord": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] },
            },
          ],
          label: "Add",
        },
      ],
    },

    "Mystic Poro": {},

    "Rebuke": {
      play: [{ op: "toHand", to: "$t1" }],
      targets: [
        { bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Return to hand..." },
      ],
    },

    "Shipyard Skulker": {},

    "Teemo, Scout": { play: [buff("source", 3)] },
  });
})();
